//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		name:'contain',
		props:{
			list:{
				type:Array,
				default:()=>{
					return []
				}
			},
			animation_status:{
				type:Number,
				default:0
			}
		},
		data(){
			return{
				tabulation:[],
				golden:true
			}
		},
		
		methods:{
			//替换金
			isGolden(){
				let arr = this.list.concat()

				this.golden = arr.every(item => item.groupId == 3)
				if(!this.golden){//有金
					this.$emit('togolden',this.golden)
					let listing = arr.filter(item => item.groupId != 3)//正常饰品
					listing.push({
							gold:true,
							text:"罕见的特殊物品"
					})

					this.tabulation = listing;
				}else{
					this.tabulation = arr
				}
			}
		},
		
		watch:{
			list(v){
				if(v.length > 0){
					this.isGolden()
				}
			}
		}
	}
